import { ReactNode } from 'react';
import { useBrightSaaSAssets } from '../hooks/useBrightSaaSAssets';
import { ModalProvider } from '../context/ModalContext';
import { BrightSaaSMenu } from './BrightSaaSMenu';
import { BrightSaaSFooter } from './BrightSaaSFooter';
import { BrightSaaSModalHost } from './BrightSaaSModalHost';
import { CookieConsentBanner } from './CookieConsentBanner';

interface Props {
  children: ReactNode;
}

export function BrightSaaSLayout({ children }: Props) {
  const cssReady = useBrightSaaSAssets();

  return (
    <ModalProvider>
      {!cssReady && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: '#0a0a0f',
            zIndex: 9999,
          }}
        />
      )}
      <div
        className="nk-app-root has-mask"
        style={{ visibility: cssReady ? 'visible' : 'hidden' }}>
        <div className="bg-mask-wraper h-800px">
          <div className="bg-mask bg-glow-a" />
          <div className="bg-pattern-grid-plus-dot blend-left-right-bottom-large bg-mask has-meteors" />
        </div>
        <BrightSaaSMenu />
        {children}
        <BrightSaaSFooter />
        <CookieConsentBanner />
      </div>
      <BrightSaaSModalHost />
    </ModalProvider>
  );
}
